import { ReactElement } from 'react';
import { ConnectedEndSession } from '../../Modals/EndSession/container';
import { ExtendSessionModalContainer } from '../../Modals/ExtendSession/container';
import { RenameSessionModalContainer } from '../../Modals/RenameSession/container';
import { ConnectedResetSessionModal } from '../../Modals/ResetSession/container';
import { SaveAndEndSessionModalContainer } from '../../Modals/SaveAndEndModal/container';
import { TimerExpiredModalContainer } from '../../Modals/TimerExpiredModal/container';
import { ActionsBar } from '../../TopActions/ActionsBar';

export const ActionsBarWrapper = (): ReactElement => (
  <>
    <ActionsBar />
    <TimerExpiredModalContainer />
    <ConnectedEndSession />
    <SaveAndEndSessionModalContainer />
    <ConnectedResetSessionModal />
    <RenameSessionModalContainer />
    <ExtendSessionModalContainer />
  </>
);
